import React from "react";

/**
 * sb = "sentence break".
 * Inserts a simple <br /> (NOT a new paragraph — same line-height, no extra margin)
 * after every sentence-ending period, so the next sentence starts on a new line.
 *
 * Only breaks on ". " (period + whitespace) followed by an opening quote or an
 * uppercase letter. This deliberately skips: decimals (period + digit),
 * lowercase abbreviations (e.g. "es."), URLs and emails (no whitespace after dot),
 * and prices (Italian decimals use a comma). Copy is never altered.
 */
export function sb(text) {
  if (typeof text !== "string") return text;
  const parts = text.split(/(?<=\.)\s+(?=["«“]?[A-ZÀÈÉÌÒÙ])/);
  if (parts.length === 1) return text;
  return parts.map((p, i) => (
    <React.Fragment key={i}>
      {p}
      {i < parts.length - 1 && <br />}
    </React.Fragment>
  ));
}
